import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import * as data from './routes.json';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ParametroService {
    controller: string = "parametro/";

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    };

    constructor(
        private http: HttpClient,
        private config: ConfigService,
        private router: Router,
    ) {
    }

    getEstadoPago(): Observable<any> {
        return this.http.get<any>(this.config.apiUrl + this.controller + "estado-pago", this.httpOptions);
    }
}